module.exports = __webpack_public_path__ + "img/gh-36204-4-24.prt.fdde61d5.jpg";